module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 003.3d7fbb83.jpg";